import React from 'react';
import styled, { css } from 'styled-components';
import { layout, media } from 'src/components/base';
import { Link } from 'react-router-dom';

export const Tabs = styled.nav`
  display: flex;
  flex-direction: row;
  align-items: bottom;

  ${media.mediumDown`
    max-width: 100vw;
  `};
`;

interface ITabs extends Sticky {
  background?: boolean;
  borderBottom?: boolean;
  bleed?: { left: number; right: number };
}

interface Sticky {
  isSticky?: boolean;
}

export const TabsBackground = styled.div<ITabs>(
  props => css`
    position: relative;
    overflow: hidden;
    display: flex;
    width: 100%;

    ${props.background &&
    props.isSticky &&
    css`
      overflow: unset;

      :before {
        content: '';
        position: absolute;
        background-color: ${props.theme.bg.primary};
        left: ${props.bleed?.left ?? 0}px;
        right: ${props.bleed?.right ?? 0}px;
        z-index: -1;
        height: 100%;
        border-bottom: 1px solid ${props.theme.lines.primary};
      }
    `}

    ${!props.background &&
    css`
      border-bottom: 1px solid ${props.theme.lines.primary};
    `}
  `
);

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;

  ${media.smallOnly`
    overflow-x: auto;
  `}

  ${media.mediumUp`
    margin: 0 ${layout.measurements.spacing050};
  `}
`;

type TabProps = {
  active?: boolean;
  to?: string;
};

export const TabLink = styled(({ active, ...rest }) => (
  <Link {...rest} />
))<TabProps>`
  height: 100%;
  display: flex;
  align-items: center;
  padding: 0 ${layout.measurements.spacing100};
  font-weight: 600;
  cursor: pointer;
  color: ${props => props.theme.colors.base500};
  transition: box-shadow 0.1s linear;
  white-space: nowrap;

  a:hover,
  &:hover {
    color: ${props => props.theme.colors.base600};
  }

  ${props =>
    props.active &&
    css`
      box-shadow: inset 0 -5px 0 -1px ${p => p.theme.colors.maybeBlue500};
      color: ${p => p.theme.text.primary};

      a:hover,
      &:hover {
        color: inherit;
      }
    `};
`;

export const Image = styled.div`
  margin-right: ${layout.measurements.spacing050};
`;
